export const NO_RESULTS = 'Ingen søgeresultater...';